import React from "react";
import { Tooltip } from "../../UI/Tooltip/Tooltip";

export const generalStatuses = {
  active: {
    color: '#D9F9DB',
    textColor: '#212529',
    iconColor: '#32C967'
  },
  error: {
    color: '#FBDCDC',
    textColor: '#212529',
    iconColor: '#ED1343'
  }
}

export const GeneralStatusLabel = ({ children, status = null, color = '#888', textColor = '#222', description, ...props }) => {
  let className = `GeneralStatusLabel`;

  if (props.className) {
    className += ` ${props.className}`;
  }

  if (status != null) {
    color = status.color;
    textColor = status.textColor;
  }

  return <>
    <Tooltip className={className} style={{ '--color': color }} description={description}>
      <span style={{ color: textColor }}>{children}</span>
    </Tooltip>
  </>;
};
